import { ErrorObject } from '../../../helpers/types';
import dot from 'dot-object';

export const extractError = (errors?: ErrorObject, name?: string): string => {
  if (errors && name) {
    return errors[name] || dot.pick(name, errors);
  }
  return '';
};
